import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { adminServices } from "../services/AdminServices";
import { Button } from "bootstrap";

const OtpPage = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [errorLogin, setErrorLogin] = useState('');
  const [loading, setLoading] = useState('');
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [timeLeft, setTimeLeft] = useState(300);
  const [failedAttempts, setFailedAttempts] = useState(2);
  useEffect(() => {
    // Timer countdown for 5 minutes
    if (isResendDisabled) {
      const interval = setInterval(() => {
        setTimeLeft(prev => {
          if (prev <= 1) {
            clearInterval(interval);
            setIsResendDisabled(false); // Enable button after 5 minutes
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
      return () => clearInterval(interval);
    }
  }, [isResendDisabled]);
  const handlePassword = event => {
    setPassword(event.target.value);
  };
  const resendOtp = async () => {
    setLoading("Resending OTP...");
    const secretKey = localStorage.getItem("secretKey");
    const emailAddr = localStorage.getItem("emailAddr");
    if (!secretKey || !emailAddr) {
      console.error("Missing required fields in localStorage.");
      return;
    }
    await adminServices.postData('regenerate-otp?emailAddress=' + emailAddr + "&secretKey=" + secretKey, {}).then(response => {
      if (response.status === 200) {
        //console.log("OTP Resent Successfully!");
        setLoading("");
        setIsResendDisabled(true); // Disable button for 5 minutes
        setTimeLeft(300); // Reset timer
      }
    }).catch(error => {
      console.error("Failed to resend OTP:", error);
    });
  };
  const Login = async () => {
    setErrorLogin('');
    setLoading('Verifying OTP, please wait!');
    await adminServices.verify(password).then(r => {
      if (r.status == 200) {
        localStorage.setItem('appToken', r.data.token);
        navigate('/colony-selection');
      }
    }).catch(e => {
      if (e.status == 409) {
        if (failedAttempts === 0) {
          setErrorLogin("Maximum number of attempts reached. will be redirected to login page automatically");
          setTimeout(() => {
            window.location.href = "/";
          }, 3000);
          return;
        }
        setErrorLogin("Verification failed, please try again");
        setFailedAttempts(prev => prev - 1);
        setLoading('');
        return;
      }
    });
  };
  return <div className="mainContainer">
      <div className="loginPageContainer">
        {/* OTP Input Section */}
        <div className="loginPartition2">
          <div className="rightPart">
            <div>
              <p className="xl medium">Verify OTP</p>
              <p className="r light">An email with a One Time Pin has been sent to your registered email.</p>
              <div style={{
              height: "25px"
            }}></div>
              <div className="loginFields regular">
                <p>One Time Pin</p>
                <input id="password" className="m" type="password" placeholder="********" value={password} onChange={handlePassword} maxLength="6" readOnly={failedAttempts === 0}></input>
              </div>

              <div className="flexRow" style={{
              color: '#FF0000',
              marginBottom: 15,
              justifyContent: 'center'
            }}>
                {errorLogin}
              </div>

              <div className="flexRow" style={{
              color: 'green',
              marginBottom: 15,
              justifyContent: 'center'
            }}>
                {loading}
              </div>

              <div className="flexRow">
                <button className="btn btn-secondary btn-xs" disabled={isResendDisabled} onClick={resendOtp}>
                  {!isResendDisabled ? "Resend OTP" : `Resend in ${timeLeft} seconds`}
                </button>
              </div>
              <div style={{
              height: "20px"
            }}></div>
              <div className="loginButton">
                <Link style={{
                textDecoration: "none"
              }} onClick={Login}>
                  <p className="r">Verify</p>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default OtpPage;